/** "5:47.706" -> seconds (347.706). Returns null if unparseable. */
export function raceTimeToSeconds(t: string | null | undefined): number | null {
  if (!t) return null;
  const m = String(t).match(/(\d+):(\d+(?:\.\d+)?)/);
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
}

/** seconds -> "m:ss.t" */
export function secondsToRaceTime(s: number | null | undefined, decimals = 1): string {
  if (s === null || s === undefined || !Number.isFinite(s)) return "—";
  const mins = Math.floor(s / 60);
  const rem = s - mins * 60;
  return `${mins}:${rem.toFixed(decimals).padStart(decimals ? 3 + decimals : 2, "0")}`;
}

export function pct(v: number | null | undefined, digits = 0): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return "—";
  // Scorecard rates come as 0..1
  return `${(v * 100).toFixed(digits)}%`;
}

export function usd(v: number | null | undefined): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return "—";
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

/** Rounds to the nearest $1,000 and renders like "$14K". Dash if missing. */
export function usdK(v: number | null | undefined): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return "—";
  return `$${Math.round(v / 1000)}K`;
}

export function int(v: number | null | undefined): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return "—";
  return Math.round(v).toLocaleString("en-US");
}

export function orDash(v: string | number | null | undefined): string {
  return v === null || v === undefined || v === "" ? "—" : String(v);
}

/** Alphabetical sort key that ignores a leading "University of" / "The" / "College of"
 *  so "University of Alabama" sorts under A. */
export function sortableName(name: string): string {
  let s = name.trim();
  let prev;
  do {
    prev = s;
    s = s.replace(/^(the|university of|college of)\s+/i, "");
  } while (s !== prev);
  return s.toLowerCase();
}
